export class PDDAnswerRulesService {
    constructor() {
        this.rules = {
            'privacy_management-marketing_channels': this.evaluateMarketingChannels,
            'risk_management-sanciones_types': this.evaluateSancionesTypes,
            'personal_management-servctrlhorario_types': this.evaluateControlHorarioTypes,
            'personal_management-empherramientascontrolemp_types': this.evaluateHerrControlEmpleadoTypes,
            'personal_management-imparteformacionesempleados_types': this.evaluateImparteFormacionesEmpleadoTypes,
            'autocomplete_management-actuacionespdd': this.evaluateActuacionesPDD,
            'autocomplete_management-delete_information_mechanism': this.evaluateDelateInformationMechanisms,
            'autocomplete_management-ms_soporte_types': this.evaluateMsSoporteTypes,
            'autocomplete_management-ms_modo_types': this.evaluateMsModoTypes,
            'autocomplete_management-ms_ubi_types': this.evaluateMsUbiTypes,
        };
        this.modalRules = {
            web_presence: this.evaluateWebsiteServicesFromEntries,
        };
    }
    evaluateBinaryDerivedAnswers(question, value, allAnswers) {
        switch (question.variableName) {
            case 'cig_actuacionespdd_c':
                return { cig_actuprevcumplinorm_c: value };
            case 'cig_ds_auditext_c':
                return { cig_audi_sometido_c: value };
            case 'cig_ms_au_c':
                return { cig_ms_mecanismosautenticacion_c: value };
            default:
                return {};
        }
    }
    evaluateDerivedAnswers(question, selectedValues) {
        const values = Array.isArray(selectedValues) ? selectedValues : [selectedValues];
        const handler = this.rules[question.id];
        return handler ? handler.call(this, question, values) : {};
    }
    evaluateDerivedAnswersFromModalEntries(question, entries) {
        const handler = this.modalRules[question.id];
        return handler ? handler.call(this, question, entries) : {};
    }
    evaluateMsSoporteTypes(question, selectedValues) {
        const publicityVars = [
            'cig_ms_soportearchi_c',
            'cig_ms_soportecarpetas_c',
            'cig_ms_soportesin_c',
        ];
        const hasAny = selectedValues.some((v) => publicityVars.includes(v));
        if (hasAny) {
            return {
                has_conservation_paper_document: '1',
            };
        }
    }
    evaluateMsModoTypes(question, selectedValues) {
        const publicityVars = ['cig_ms_modoinvbajollave_c', 'cig_ms_modoinvsinllave_c', 'cig_ms_modosininvllave_c', 'cig_ms_modosininvsinllave_c'];
        const hasAny = selectedValues.some((v) => publicityVars.includes(v));
        if (hasAny) {
            return {
                has_conservation_paper_document: '1',
            };
        }
    }
    evaluateMsUbiTypes(question, selectedValues) {
        const publicityVars = ['cig_ms_ubibandejas_c', 'cig_ms_ubicajones_c', 'cig_ms_ubicajasarchiv_c', 'cig_ms_ubiarmario_c'];
        const hasAny = selectedValues.some((v) => publicityVars.includes(v));
        if (hasAny) {
            return {
                has_conservation_paper_document: '1',
            };
        }
    }
    evaluateDelateInformationMechanisms(question, selectedValues) {
        const publicityVars = ['cig_ms_destrucpapelera_c', 'cig_ms_destrucdestruc_c', 'cig_ms_destrucequipos_c'];
        const hasAny = selectedValues.some((v) => publicityVars.includes(v));
        return {
            cig_ms_mecanismodestruccion_c: hasAny ? '1' : '0',
        };
    }
    evaluateMarketingChannels(question, selectedValues) {
        const publicityVars = [
            'cig_envpromocorreopostal_c',
            'cig_envpromoemail_c',
            'cig_envpromoredessociales_c',
            'cig_envpromomensajeriainst_c',
            'cig_envpromotel_c',
        ];
        const hasAnyChannel = selectedValues.some((v) => publicityVars.includes(v));
        return {
            cig_envpromopubli_c: hasAnyChannel ? '1' : '0',
        };
    }
    evaluateSancionesTypes(question, selectedValues) {
        const formVars = ['cig_sanciones_rgpdlssi_c', 'cig_sanciones_rh_c'];
        const hasSomeVar = selectedValues.some((v) => formVars.includes(v));
        return {
            cig_sanciones_normativa_c: hasSomeVar ? '1' : '0',
        };
    }
    evaluateControlHorarioTypes(question, selectedValues) {
        const formVars = [
            'cig_ch_mec_manual_c',
            'cig_ch_mec_tacceso_c',
            'cig_ch_mec_biometria_c',
            'cig_ch_mec_geo_c',
            'cig_ch_mec_apps_c',
            'cig_ch_mec_login_c',
        ];
        const hasSomeVar = selectedValues.some((v) => formVars.includes(v));
        return {
            cig_servctrlhorario_c: hasSomeVar ? '1' : '0',
        };
    }
    evaluateHerrControlEmpleadoTypes(question, selectedValues) {
        const formVars = ['cig_ce_geo_c', 'cig_ce_video_c', 'cig_ce_app_c'];
        const hasSomeVar = selectedValues.some((v) => formVars.includes(v));
        return {
            cig_tc_empherramientascontrolemp_c: hasSomeVar ? '1' : '0',
        };
    }
    evaluateImparteFormacionesEmpleadoTypes(question, selectedValues) {
        const formVars = ['cig_formacionpdd_c', 'cig_formacionteletrabajo_c'];
        const hasSomeVar = selectedValues.some((v) => formVars.includes(v));
        return {
            cig_f_imparteformacionesempleados_c: hasSomeVar ? '1' : '0',
        };
    }
    evaluateActuacionesPDD(question, selectedValues) {
        // basta con comprobar si hay un "1" en el array
        const hasActuaciones = selectedValues.includes('1');
        return {
            // asigna 1 si la pregunta binaria o múltiple devolvió "1"
            cig_actuprevcumplinorm_c: hasActuaciones ? '1' : '0',
        };
    }
    evaluateWebsiteServicesFromEntries(question, entries) {
        const webServicesVars = ['cweb_ventaproductos_c', 'cweb_ventaservicios_c', 'cweb_ventareservas_c'];
        const hasComercioElectronico = entries.some((entry) => Array.isArray(entry['cweb_website_services_c']) && entry['cweb_website_services_c'].some((v) => webServicesVars.includes(v)));
        return {
            cweb_comercioelectronico_c: hasComercioElectronico ? '1' : '0',
        };
    }
}
